import { render } from "./NavbarDigdaya.vue?vue&type=template&id=056f9d79&scoped=true"
import script from "./NavbarDigdaya.vue?vue&type=script&lang=js"
export * from "./NavbarDigdaya.vue?vue&type=script&lang=js"

import "./NavbarDigdaya.vue?vue&type=style&index=0&id=056f9d79&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056f9d79"]])

export default __exports__